import { useQuery } from '@tanstack/react-query'
import { dashboardClient } from './index'

export const useMyProfileQuery = () => {
  return useQuery({
    queryKey: ['my-profile'],
    queryFn: () => dashboardClient.v1.getMyProfile().then(r => r.data),
  })
}
